import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getJournal } from "@/lib/api";

export default function Journal() {
  const [items, setItems] = useState([]);
  useEffect(() => { getJournal().then(setItems); }, []);

  return (
    <div data-testid="journal-page">
      <section className="pt-28 lg:pt-44 pb-16">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
          <div className="label-eyebrow">Journal</div>
          <h1 className="serif mt-7 text-[48px] sm:text-[80px] leading-[1] tracking-tight">
            Journal <span className="italic">Entries</span>.
          </h1>
          <p className="mt-12 max-w-2xl text-[18px] leading-[1.8] text-[#2E2B27]">
            Read the latest Journal Entries from Studio A — quiet writing on skin, the nervous system, and the slow practice of caring for yourself.
          </p>
        </div>
      </section>

      {/* EDITORIAL BREATH */}
      <section className="py-8">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10 grid grid-cols-12 gap-6 items-start">
          <div className="col-span-5">
            <img src="/images/editorial/olive-branch.jpg" alt="Olive branches in a ceramic vessel against a plaster wall." data-testid="journal-olive-image" className="w-full aspect-[4/5] object-cover" />
          </div>
          <div className="col-span-7 self-center">
            <p className="pull-quote text-[22px] sm:text-[26px] px-2 sm:px-8">Small, quiet essays on skin, stress and the art of slowing down.</p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
          <div className="label-eyebrow">Latest</div>
          <ul className="mt-8">
            {items.map((j) => (
              <li key={j.slug} className="border-t border-[#D5CDBF] last:border-b">
                <Link
                  to={`/journal/${j.slug}`}
                  data-testid={`journal-${j.slug}`}
                  className="group grid grid-cols-12 gap-6 py-12 lg:py-14 items-baseline"
                >
                  <div className="col-span-12 sm:col-span-3 label-eyebrow">{j.category}</div>
                  <div className="col-span-12 sm:col-span-7">
                    <h2 className="serif text-[28px] sm:text-[36px] leading-tight group-hover:text-[#A96A53] transition-colors">{j.title}</h2>
                    <p className="mt-3 text-[15px] leading-relaxed text-[#55524C] max-w-xl">{j.excerpt}</p>
                  </div>
                  <div className="col-span-12 sm:col-span-2 text-right text-[12px] text-[#6E6A63] tracking-wide">{j.date}</div>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-20 bg-[#F0EDE6] border-t border-[#D5CDBF]">
        <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
          <div className="label-eyebrow">More to come</div>
          <h2 className="serif mt-6 text-[28px] sm:text-[36px] leading-tight max-w-2xl">New entries arrive quietly.</h2>
          <p className="mt-6 text-[16px] leading-[1.8] text-[#55524C] max-w-xl">Published as they're finished — not on a schedule. Subscribe below and they'll find you.</p>
        </div>
      </section>
    </div>
  );
}
